import styled from "@emotion/styled";
import { LAYER_ONE, ZERO } from "constants/z-index";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH } from "constants/vp-sizes";
import DesktopHeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
const HEADER_HORIZONTAL_PADDING = `${DesktopHeaderConstants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
const getDefaultMargin = (margin)=>`calc((100vw - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH}) / 2 + ${HEADER_HORIZONTAL_PADDING})`;
export const StyledParallaxVideoAssetComponent = styled.div`
	width: 100%;
	height: ${({ scrollThreshold })=>`calc(100vh + ${scrollThreshold})`};
	position: relative;

	.video-container {
		height: 100vh;

		z-index: ${ZERO};

		position: sticky;
		top: 0;

		.asset-inner {
			height: 100%;
			.video-component {
				display: unset;
			}
			video {
				filter: brightness(${({ videoBrightness })=>videoBrightness || "0.4"});
				transition: all 2s;
				object-fit: cover;
			}

			&.dark {
				video {
					filter: brightness(${({ videoBrightness })=>videoBrightness || "0.4"});
				}
			}
		}
	}

	.text-container {
		position: relative;
		z-index: ${LAYER_ONE};
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: ${({ marginBetweenColumns })=>marginBetweenColumns};
		justify-content: space-between;

		.center-paragraph {
			position: absolute;
			top: -60vh;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: ${LAYER_ONE};
			width: 100%;
			max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH};
			text-align: center;
			padding: 0 ${HEADER_HORIZONTAL_PADDING};
			transition: top 0.1s ease-out;
		}

		.column {
			display: flex;
			flex-direction: column;
			gap: ${({ marginBetweenSections })=>marginBetweenSections};
			flex: 1;

			&.left-column {
				margin-left: ${({ columnMarginLeft })=>`calc(max(${HEADER_HORIZONTAL_PADDING}, ${columnMarginLeft || "0px"}, ${getDefaultMargin(columnMarginLeft)}))`};
			}

			&.right-column {
				margin-right: ${({ columnMarginRight })=>`calc(max(${HEADER_HORIZONTAL_PADDING} ,${columnMarginRight || "0px"}, ${getDefaultMargin(columnMarginRight)}))`};
			}
		}

		&:has(.center-paragraph) {
			.column.left-column {
				max-width: 50%;
			}
		}
	}
`;
